import { RgChildren as i, RG_TYPE as e } from "@project-rouge/rg-core";
const t = (r) => i.Building.includes(r.type) ? [e.Core, e.Corridor, e.TechnicalSpace, e.EmptySpace, e.Entrance].includes(r.type) : !1;
export {
  t as isBaseBuildObject
};
//# sourceMappingURL=index2.js.map
